// extracted by mini-css-extract-plugin
module.exports = {"title":"_88735a40","container":"_a8abe507","copy":"_22a50a65","searchTerm":"_3a785220"};